import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Grid, Typography, Link, IconButton } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box component="footer" sx={{ bgcolor: 'primary.main', color: 'white', py: 6, mt: 'auto' }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom>
              Solverwatch
            </Typography>
            <Typography variant="body2">
              A comprehensive calculator application offering a wide range of calculators for financial, fitness & health, mathematical, and other everyday calculations.
            </Typography>
            <Box sx={{ mt: 2 }}>
              <IconButton color="inherit" aria-label="Facebook" component="a" href="#" target="_blank">
                <FacebookIcon />
              </IconButton>
              <IconButton color="inherit" aria-label="Twitter" component="a" href="#" target="_blank">
                <TwitterIcon />
              </IconButton>
              <IconButton color="inherit" aria-label="Instagram" component="a" href="#" target="_blank">
                <InstagramIcon />
              </IconButton>
              <IconButton color="inherit" aria-label="LinkedIn" component="a" href="#" target="_blank">
                <LinkedInIcon />
              </IconButton>
            </Box>
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom>
              Calculator Categories
            </Typography>
            <Link component={RouterLink} to="/financial" color="inherit" display="block" sx={{ mb: 1 }}>
              Financial Calculators
            </Link>
            <Link component={RouterLink} to="/math" color="inherit" display="block" sx={{ mb: 1 }}>
              Math Calculators
            </Link>
            <Link component={RouterLink} to="/fitness" color="inherit" display="block" sx={{ mb: 1 }}>
              Fitness & Health Calculators
            </Link>
            <Link component={RouterLink} to="/other" color="inherit" display="block" sx={{ mb: 1 }}>
              Other Calculators
            </Link>
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom>
              Legal
            </Typography>
            <Link component={RouterLink} to="/about" color="inherit" display="block" sx={{ mb: 1 }}>
              About Us
            </Link>
            <Link component={RouterLink} to="/privacy" color="inherit" display="block" sx={{ mb: 1 }}>
              Privacy Policy
            </Link>
            <Link component={RouterLink} to="/terms" color="inherit" display="block" sx={{ mb: 1 }}>
              Terms of Service
            </Link>
            <Link component={RouterLink} to="/cookies" color="inherit" display="block" sx={{ mb: 1 }}>
              Cookie Policy
            </Link>
            <Link component={RouterLink} to="/sitemap" color="inherit" display="block" sx={{ mb: 1 }}>
              Sitemap
            </Link>
          </Grid>
        </Grid>
        
        <Box mt={5}>
          <Typography variant="body2" align="center">
            {'© '}
            {currentYear}
            {' Solverwatch. All rights reserved.'}
          </Typography>
          <Typography variant="body2" align="center" sx={{ mt: 1 }}>
            {'Built with '}
            <Link color="inherit" href="https://reactjs.org/" target="_blank" rel="noopener">
              React
            </Link>
            {' and '}
            <Link color="inherit" href="https://mui.com/" target="_blank" rel="noopener">
              Material-UI
            </Link>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
